export default __webpack_public_path__ + "static/SectionTwo_02_03@2x-7662128ec826517fac5fd97600ee82a4.png";